import { render, staticRenderFns } from "./chateau-pichon-lalande.vue?vue&type=template&id=49363674&scoped=true"
import script from "./chateau-pichon-lalande.vue?vue&type=script&lang=js"
export * from "./chateau-pichon-lalande.vue?vue&type=script&lang=js"
import style0 from "./chateau-pichon-lalande.vue?vue&type=style&index=0&id=49363674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49363674",
  null
  
)

export default component.exports